import React from "react";
import { Trophy, Users, TrendingUp } from "lucide-react";
import { ProgressWave } from "@/components/ProgressWave";
import { money } from "@/lib/api";

const medal = ["#c99a4e", "#a9a795", "#c97049"];

export function LeaderboardTable({ rows = [], highlightTeamId = null }) {
  if (!rows.length) {
    return (
      <div className="rounded-2xl border border-dashed border-[#e4d8c4] bg-white p-10 text-center text-[#7c7a6a]">
        No teams on the board yet. Once teams start raising, they'll appear here.
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="leaderboard-team-table">
      {rows.map((r) => {
        const mine = r.team_id === highlightTeamId;
        return (
          <div
            key={r.team_id}
            data-testid={`leaderboard-row-${r.team_id}`}
            className={`rounded-2xl border bg-white p-4 sm:p-5 transition-shadow hover:shadow-md ${
              mine ? "border-[#c97049] ring-2 ring-[#c97049]/30" : "border-[#e4d8c4]"
            }`}
          >
            <div className="flex items-center gap-4">
              <div
                className="grid h-11 w-11 shrink-0 place-items-center rounded-xl font-heading text-lg font-extrabold text-white"
                style={{ background: medal[r.rank - 1] || "#65949c" }}
              >
                {r.rank <= 3 ? <Trophy className="h-5 w-5" /> : r.rank}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                  <span className="truncate font-heading text-lg font-bold text-[#00334a]">
                    {r.name}
                  </span>
                  {mine && (
                    <span className="rounded-full bg-[#f3e7db] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#b05e3c]">
                      Your team
                    </span>
                  )}
                </div>
                <div className="mt-0.5 flex flex-wrap items-center gap-x-4 gap-y-0.5 text-xs text-[#7c7a6a]">
                  <span className="inline-flex items-center gap-1">
                    <Users className="h-3.5 w-3.5" /> {r.member_count} members
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <TrendingUp className="h-3.5 w-3.5" /> {r.donors} gifts
                  </span>
                </div>
              </div>
              <div className="text-right">
                <div className="font-heading text-xl font-extrabold text-[#65949c]">
                  {money(r.raised)}
                </div>
                <div className="text-xs font-semibold text-[#7c7a6a]">
                  {r.pct}% of {money(r.goal)}
                </div>
              </div>
            </div>
            <div className="mt-3">
              <ProgressWave pct={r.pct} height="h-2.5" showMilestones />
            </div>
          </div>
        );
      })}
    </div>
  );
}
